export default __webpack_public_path__ + "static/ubuntu.9824f152.svg";